require('./style.css');
let Utils = require('f.component.util.pc');
let device = Utils.device;

let indexUrl = '//zhibo.ifeng.com/';
// let mUrl = '//izhibo.ifeng.com/live.html?liveid=';
let liveUrl = '//zhibo.ifeng.com/live.html?liveid=';

let Related = require('./modules/relatedNews'); // 相关推荐
let SportsEventData = require('./modules/eventData'); // 体育事件数据
let SportMatch = require('./modules/sportMatch'); // 体育比赛进展

if (params.liveid === '' || typeof params.liveid === 'undefined') {
    window.location.href = indexUrl;
}

// if (device.type === 'mobile' || device.type === 'pad') {
//     window.location.href = mUrl + params.liveid;
// }

let header = require('./modules/header/'),
    Share = require('f.component.share.pc'),
    Message = require('f.compenont.messageCenter'),
    /* 弹幕*/
    Barrage = require('f.compenont.barrage.pc');
let ChartList = Barrage.ChartList,
    checkSid = Barrage.checkSid,
    Input = Barrage.Input,
    DataCenter = Barrage.DataCenter,
    PlayBackDataCenter = Barrage.PlayBackDataCenter;

let LivePage = require('f.component.pagelist.pc');

// import PresentUI from 'f.component.present.pc';
import dianzan from 'f.component.dianzan.pc';

/* 视频*/
let live_video = require('f.component.videohead.pc');

let Tab = require('./modules/tab');

window.chartList = new ChartList();
let subject = window.getSubject && typeof window.getSubject === 'function' && window.getSubject();
// debugger

let Page = {
    init: function(options) {
        // console.dir(options)
        this.info = options.info;
        this.video = options.compenonts.video;
        this.isLive = this.video.isLive; // 直播or点播
        this.list = this.video.list;
        this.barrage = options.compenonts.barrage;
        this.gifts = options.compenonts.present.presentInfo;
        this.present = options.compenonts.present;
        this.isDanmu = this.video.isDanmu;
        this.isChat = 0; // 是否允许聊天0代表关，1代表开
        this.isRelated = this.info.isRelated; // 是否允许显示 0代表关，1代表开
        this.videoLen = this.list.length; //
        this.admain = this.info.admain; // 广告主图
        this.adbackground = this.info.adbackground; // 广告背景
        this.isSport = 0; //  体育直播-世界杯 1展示 0 不展示
        this.praiseType = 1;
        if (this.videoLen > 0) {
            this.initDom(); // 定义各组件外部容器
            this.initParams(); // 获取各组件所需外部参数
            this.initCompenonts(); // 初始化各组件
            this.initEvent(); // 绑定并监控各组件信息
            this.initHook(); // 初始化完成之后的
        } else {
            // 跳转图文地址
            window.location.href = liveUrl + params.liveid;
        }
    },
    initDom: function() {
        this.$wrap = $('.p-wrap');
        this.info.state = this.getState(); // 直播状态
        this.$wrap.append(header(this.info));
        this.$share = $('.c-share-root');
        this.$video = $('.c-core-root');
        if (this.isChat) {
            this.$chartRoot = $('.c-chart-root');
            this.$chartRoot.addClass('blackBg');
            chartList.renderTo(this.$chartRoot);
            this.$chart = $('.c-chart');
            $('.c-right').show();
        }
        this.$online = $('.online')[0];
        // this.$tulist = $('.p-othernews')[0];
        this.$turight = $('.o-right')[0]; // 图文右侧盒子
        this.$header = $('.header')[0]; // 页头
    },
    initParams: function() {
        let info = this.info;
        let livewidth = '100%';
        let liveheight = '100%';
        if (this.isChat) {
            // 允许聊天
            livewidth = 899;
            liveheight = 506;

            // 弹幕输入框
            this.inputOptions = {
                url: window.location.href,
                title: info.title
            };

            this.pb_inputOptions = {
                size: 14,
                color: '0Xffffff'
            };
            // 直播弹幕
            // console.log(params.liveid);
            this.on_barrageOptions = {
                id: params.liveid,
                getUrl: window.location.protocol + '//danmaku.ifeng.com/get/recent/'
            };
            // 点播弹幕
            this.pb_barrageOptions = this.barrage;
            this.pb_barrageOptions.id = this.list[0].liveVideoId; // 第一个视频直播id
            // console.log("pb_barrageOptions===",this.pb_barrageOptions);
        }
        // 视频
        this.videoOptions = {
            liveid: params.liveid,
            container: this.$video,
            livewidth: livewidth,
            liveheight: liveheight,
            isLive: this.isLive,
            isDanmu: this.isDanmu,
            list: this.list.map((item) => {
                item.subject = subject;
                return item;
            }),
            start_date: this.info.start_date
        };

        // 分享
        this.shareOptions = {
            order: ['sina', 'weixin', 'qqzone', 'qq'],
            data: {
                title: info.title,
                description: info.intro,
                url: window.location.href,
                picUrl: info.sharepic
            },
            wxqrcodeURl: '//qrcode.ifeng.com/qrcode.php',
            targetDom: this.$share
        };

        this.hasPage = 0; // 是否显示图文列表
    },
    initCompenonts: function() {
        // var tabHtml = Tab(tabOptions);
        // $('.p-wrap').append(tabHtml);
        //
        // this.tab = $(tabHtml);
        let praiseType = this.praiseType;
        this.message = new Message(
            {
                url: this.info.ws,
                roomid: params.liveid,
                source: 'live',
                deviceid: Utils.getCookie('sid') || Utils.getCookie('userid') || Utils.getRandomUid(),
                version: '1.0.0',
                app: 'pc',
                praise_type: this.info.praiseType || '2'
            },
            function() {
                console.log('出错啦＝＝＝》', arguments);
            }
        );

        if (this.videoOptions) {
            // 视频
            // debugger
            live_video.init(this.videoOptions);
        }
        if (this.shareOptions) {
            // 分享
            // new Share(this.shareOptions);
        }
        if (this.isChat) {
            // 是否有聊天
            if (this.isLive) {
                // 直播弹幕输入框
                this.input = new Input(this.inputOptions);
            } else {
                // 点播弹幕输入框
                this.input = new Input(this.pb_inputOptions);
            }
            this.input.renderTo(this.$chart);
            if (praiseType !== '1') {
                new dianzan({ message: this.message, dianzan_config: { praiseType }, containerClass: '.c-core-root' });
            }
            // let { presentInfo, queue_config, present_config, effect_config, goldEgg_config = {} } = this.present;

            // present_config.containerClass = '.c-left';
            // effect_config.containerClass = '.c-chart';
            // goldEgg_config.containerClass = '.c-chart';

            // let _config = {
            //     presentInfo,
            //     queue_config,
            //     present_config,
            //     effect_config,
            //     goldEgg_config,
            //     message: this.message,
            // };

            // this.presentUI = new PresentUI(_config);
        } else {
            // 无聊天则居中视频
            this.$video.closest('.c-left').addClass('center');
        }
        // 体育事件数据
        if (this.isSport) {
            // 顶部-比赛
            this.sportsMatch = new SportMatch({
                matchId: this.info.matchId,
                container: this.$header
            });
        }
        // 图文列表
        // console.log("有无图文==",this.hasPage)
        // 主图广告
        if (this.adbackground || this.admain) {
            // alert(this.admain);
            let width = document.body.clientWidth;
            if (width <= 1900) {
                $('.wrap-total').css('background', 'url(' + this.admain + ') no-repeat center 0');
                $('.wrap-total').css('background-color', '#161616');
            } else {
                $('.wrap-total').css('background', 'url(' + this.adbackground + ') no-repeat center 0');
                $('.wrap-total').css('background-color', '#161616');
            }
            // alert(width)
        }
    },
    initEvent: function() {
        let self = this;

        if (this.isChat) {
            if (this.isLive) {
                // 直播
                this.dataCenter = new DataCenter(this.on_barrageOptions); // 初始化并请求历史数据
                // 登录后才能发弹幕
                this.input.on('message', function(data) {
                    self.message
                        .getUser()
                        .then(function(result) {
                            // console.log(result);
                            if (result.type == 'user') {
                                self.appenddom(data, result); // 聊天框显示消息
                                self.message.send('danma', '101', data);
                            } else {
                                window['GLOBAL_LOGIN']();
                            }
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                });

                // 监听直播状态
                if (live_video.cutdown) {
                    live_video.cutdown.on('end', function() {
                        $('.state').html('正在直播');
                    });
                }

                // 监听广播弹幕
                this.message.on('danma:list', '201', function(datas) {
                    if (datas.code == 1 && datas.data.length > 0) {
                        for (let i = 0; i < datas.data.length; i++) {
                            datas.data[i].avatar = datas.data[i].avatar || '//p2.ifengimg.com/a/2018/0628/ifeng-logo.png';
                        }
                        chartList.add('danma', datas.data);
                    }
                });

                // this.$video.on('hover','.c-video',function () {
                //     $('.danmubox').show();
                // })
            } else {
                // 点播
                checkSid(function(sid) {});
                this.dataCenter = new PlayBackDataCenter(this.pb_barrageOptions); // 初始化并请求历史数据

                this.addDanmu();
                this.input.on('message', function(data) {
                    // console.log(data);
                    self.message
                        .getUser()
                        .then(function(result) {
                            if (result.type == 'user') {
                                let lineId = $('.c-videoList .clicked').data('lineid');
                                if (lineId) {
                                    // 播发中
                                    var offset = Math.floor(document.getElementById('js_playVideo' + lineId).get_time());
                                } else {
                                    // 未播放
                                    var offset = 0;
                                }
                                self.appenddom(data, result); // 聊天框显示消息
                                data.nickname = result.nickname;
                                data.avatar = result.avatar;
                                self.dataCenter.sendData(data, offset);
                            } else {
                                window['GLOBAL_LOGIN']();
                            }
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                });

                this.dataCenter.on('dataMax', function(datas) {
                    chartList.add('danma', datas);
                });

                this.dataCenter.on('send', function(data) {
                    chartList.add('danma', data);
                });
            }
            // 监听登录信息
            this.message.on('online:login', '201', function(datas) {
                if (datas.code == 1 && datas.data.length > 0) {
                    chartList.add('login', datas.data);
                } else {
                    // alert(datas.msg);
                }
            });
            // 监听点赞信息
            this.message.on('praise:list', '201', function(praisedata) {
                chartList.add('praise', praisedata.data);
            });

            // 监听礼物信息
            // this.message.on('gift:list', '204', function (gift_data) {
            //     var giftData = gift_data.data,
            //         itemCombo;
            //     for (var i = 0; i < giftData.length; i++) {
            //         itemCombo = giftData[i].gift.id;
            //         for (var j = 0; j < self.gifts.length; j++) {
            //             if (itemCombo == self.gifts[j].id) {
            //                 giftData[i].gift.comboname = self.gifts[j].name;
            //                 giftData[i].gift.combosrc = self.gifts[j].pic;
            //             }
            //         }
            //     }

            //     chartList.add('gift', giftData);
            // });
            // this.presentUI.event.on('present-login', function () {
            //     window['GLOBAL_LOGIN']();
            // });
        }
        // 监听在线人数
        this.message.on('online:number', '201', function(datas) {
            if (datas.code == 1) {
                let _formatCount = function(val) {
                    if (val < 10000) {
                        return val;
                    } else {
                        return (val / 10000).toFixed(1) + '万';
                    }
                };

                $(self.$online).html(_formatCount(datas.number));
            } else {
                // alert(datas.msg);
            }
        });
        // 体育赛事-比分
        if (this.isSport) {
            // 监听-比分
            this.message.on('livesports', '201', function(datas) {
                console.log('livesports--datas--', datas);
                if (datas.code == 1) {
                    console.log('code--', datas.data, self.sportsMatch.updateSportMatch);
                    self.sportsMatch.updateSportMatch(datas.data);
                } else {
                    alert(datas.msg || '有广播，但无数据返回');
                }
            });
        }
    },

    initHook: function() {
        window.initHookFun && window.initHookFun();
    },

    addDanmu: function() {
        let self = this;
        let $flash;
        // 每秒查询一次视频是否开始播放
        setInterval(function() {
            // 点播每秒都去轮询一次是否播放
            // 获取当前播放视频的线路ID和guid

            let lineId = $('.c-videoList .clicked').data('lineid');
            if (typeof lineId !== 'undefined') {
                $flash = document.getElementById('js_playVideo' + lineId);
            } else {
                $flash = document.getElementById('js_playVideo0');
            }
            if ($flash && $flash.get_time) {
                // 视频开始播放
                self.dataCenter.getRange(-1, parseInt($flash.get_time()));
                // 切换视频时需要清空消息列表
                live_video.playback.on('change', function(lineid) {
                    // 列表中视频切换时
                    chartList.clear();
                    let id = self.list[lineid].liveVideoId;
                    self.dataCenter.changeData(id);
                });
            } else {
                // 未播放，无视频列表，且不需要请求历史弹幕
                // self.dataCenter.getRange(-1, 0);//未播放则请求0时间的历史数据，触发datamax
            }
        }, 1000);
    },
    getState: function() {
        let state = '';

        let start_date = this.info.start_date;
        let end_date = this.info.end_date;
        let now = new Date().getTime();

        if (now < start_date) {
            state = '准备中';
        } else if (now > end_date) {
            state = '回放中';
        } else {
            state = '正在直播';
        }
        return state;
    },
    appenddom: function(senddata, userdata) {
        let itemInfo = userdata;
        itemInfo.content = senddata.content;
        chartList.appendInfo('danma', [itemInfo]);
    }
};

$.ajax({
    url: '//data.zhibo.ifeng.com/508df9aec9e2a/data/' + params.liveid + '/config_' + params.liveid + '.js',
    dataType: 'script',
    success: function() {
        console.log('config', config);
        const status = config.info.status; // 获取直播的状态 4为下线
        if (status === 4) {
            window.location.href = '/404.html';
        } else {
            const praiseType = (config.info && config.info.praiseType) || '2';
            let changeDianZanMode = function(praiseType) {
                if (praiseType === '1') {
                    $('body')
                        .removeClass('candleDianzan')
                        .removeClass('heartDianZan')
                        .addClass('noDianZan');
                } else if (praiseType === '3') {
                    $('body')
                        .removeClass('candleDianzan')
                        .removeClass('heartDianZan')
                        .addClass('candleDianzan');
                } else {
                    $('body')
                        .removeClass('candleDianzan')
                        .removeClass('heartDianZan')
                        .addClass('heartDianZan');
                }
            };
            window.changeDianZanMode = changeDianZanMode;
            changeDianZanMode(praiseType);
            Page.init(config);
        }
    }
});



// WEBPACK FOOTER //
// ./app/app.js